import React, { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import routesPages from '../config/routes/routes';
import NavBar from '../components/navbar/NavBar'
import Footer from '../components/footer/Footer';

const Layout: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const currentRoute = routesPages.find(route =>
      route.path === location.pathname ||
      (route.path.includes(":") && matchPath(route.path, location.pathname))
    );
    if (currentRoute) {
      document.title = currentRoute.title;
    }
  }, [location.pathname]);

  return (
    <>
      <NavBar />
      <Outlet />
      <Footer />
      <ToastContainer />
    </>
  )
}

function matchPath(routePath: string, currentPath: string): boolean {
  const routeParts = routePath.split("/");
  const currentParts = currentPath.split("/");
  if (routeParts.length !== currentParts.length) return false;
  return routeParts.every((part, i) => part.startsWith(":") || part === currentParts[i]);
}

export default Layout